export enum ExportLabelView {
    BOP = 'bop',
    FOP = 'fop',
    CautionaryBOP = 'cautionaryBop',
    CautionaryFOP = 'cautionaryFop'
  }
